import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { styles } from 'styles/components/ordersList';
import OrderItem from 'components/OrderItem';
import OrderListProps from 'types/components/OrderListProps';
import OrderContext from 'contexts/OrderContext';

export default ({ orders, children, navigation, isMediumScreen }: OrderListProps): JSX.Element => {
  const { setCurrentOrder, currentCommerce } = React.useContext(OrderContext);

  const renderMediumScreen = (): JSX.Element => {
    return (
      <>
        <View>{children}</View>
        {/*
        <View style={styles.titleColumnSmall}>
          <TouchableOpacity
            style={selectedStatus == 'Pendiente' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('Pendiente')}
          >
            <Text style={selectedStatus == 'Pendiente' ? styles.selectedText : styles.textSmall}>Pendientes</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={selectedStatus == 'En Proceso' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('En Proceso')}
          >
            <Text style={selectedStatus == 'En Proceso' ? styles.selectedText : styles.textSmall}>En Proceso</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={selectedStatus == 'Por Entregar' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('Por Entregar')}
          >
            <Text style={selectedStatus == 'Por Entregar' ? styles.selectedText : styles.textSmall}>Por Entregar</Text>
          </TouchableOpacity>
    </View>*/}
        <ScrollView style={styles.cardColumnSmall}>
          {orders.length > 0 &&
            orders.map((order: any, index) => {
              return (
                <OrderItem
                  key={index}
                  order={order}
                  onPress={() => {
                    setCurrentOrder(order);
                    navigation.navigate('OrderDetailsScreen');
                  }}
                  isMediumScreen={isMediumScreen}
                  isParkingCommerce={currentCommerce?.type.description === 'Parking'}
                />
              );
            })}
        </ScrollView>
      </>
    );
  };
  const renderLargeScreen = (): JSX.Element => {
    return (
      <>
        <View>{children}</View>
        <View style={styles.cardsContainerLarge}>
          <View style={styles.cardColumnLarge}>
            {orders.length > 0 &&
              orders.map((order: any, index) => {
                return (
                  <OrderItem
                    key={index}
                    order={order}
                    onPress={() => {
                      setCurrentOrder(order);
                      navigation.navigate('OrderDetailsScreen');
                    }}
                    isMediumScreen={isMediumScreen}
                    isParkingCommerce={currentCommerce?.type.description === 'Parking'}
                  />
                );
              })}
          </View>
        </View>
      </>
    );
  };

  return <>{isMediumScreen ? renderLargeScreen() : renderMediumScreen()}</>;
};
